"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperPage = void 0;
var system_1 = require("@mui/system");
exports.WrapperPage = (0, system_1.styled)('div')(function () { return ({
    paddingTop: '20px',
    paddingBottom: '20px',
}); });
